const config = {
  title: "Azis Alvriyanto's Personal Website",
  sort_title: 'Alvri Space',
  description:
    'A software engineer who guides the team, analyzes client needs to develop project specifications, and encourages collaboration and innovation.',
  siteUrl: 'https://azisalvriyanto.membasuh.com',
  siteLogo: '/logo.png',
  author: 'Azis Alvriyanto',
  email: 'azisalvriyanto@membasuh.com',
  language: 'en-US',
  twitterHandle: '@azisalvriyanto',
}

module.exports = config
